import { concat } from 'lodash';
import { useHistory } from 'react-router-dom';
import { makeHomeButtonProps } from './builtInItem/makeHomeButtonProps';
/** Hook that generates the site and nav menu on the left side of the app bar. */
export const useAppBarNearItems = ({ siteName, siteHomeHref, portalName, portalHomeHref, items, }) => {
    const { push } = useHistory();
    const homeButton = makeHomeButtonProps(siteName, siteHomeHref);
    return concat([
        homeButton,
        {
            key: 'portalHome',
            name: portalName,
            onClick: () => push(portalHomeHref),
        },
    ], items || []);
};
